<template>
  <form @submit.prevent="onSubmit">
    <div class="columns">
      <div class="column is-narrow">
        <b-field label="Prompt Type">
          <b-select
            @input.native="onChange"
            v-model="promptType"
            icon="question-circle"
            icon-pack="fas"
          >
            <option
              :value="prompt"
              :key="prompt"
              v-for="prompt in Object.keys(promptChoices)"
            >
              {{ promptChoices[prompt] }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>
    <b-field grouped position="is-right">
      <div class="control">
        <button class="button is-primary is-rounded" type="submit">
          Save
        </button>
      </div>
    </b-field>
  </form>
</template>

<script>
import { mapActions } from 'vuex';
import { models } from '@jessicarobins/lineaday';

export default {
  name: 'PromptSettings',
  props: ['hasSubscription', 'showPremiumModal'],
  data() {
    return {
      promptChoices: {
        ...models.prompt.promptPackFree,
        ...models.prompt.promptPackPaid,
      },
      promptType: this.$store.state.auth.settings.promptType,
    };
  },
  methods: {
    ...mapActions(['updateUserSettings']),
    onChange(event) {
      if (!this.hasSubscription) {
        console.log('user does not have a subscription');
        // throw up a banner
        this.showPremiumModal('Prompt types');

        // change it back to what it was before
        this.promptType = this.$store.state.auth.settings.promptType;
        event.target.value = this.promptType; // eslint-disable-line no-param-reassign
      }
    },
    onSubmit() {
      this.updateUserSettings({
        promptType: this.promptType,
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
